import { useNavigate } from 'react-router-dom';
import {
    Users, Camera, Package, TrendingUp,
    ChevronRight, Clock, AlertTriangle
} from 'lucide-react';
import { Card, Button } from '@components/ui';
import clsx from 'clsx';

/**
 * Hızlı Erişim — Kompakt aksiyon kartları
 * Her kart: ikon, başlık, canlı stat, ok ikonu
 */
export default function HizliErisimKartlari({ puantajStats, gunlukStats, ortalamaIlerleme }) {
    const navigate = useNavigate();

    const kartlar = [
        {
            title: 'Personel & Yoklama',
            icon: Users,
            path: '/insaat/personel',
            bg: 'bg-secondary/10',
            iconColor: 'text-secondary',
            stat: puantajStats.calisanSayisi > 0
                ? `${puantajStats.calisanSayisi} kişi çalışıyor`
                : 'Bugün kayıt yok',
        },
        {
            title: 'Şantiye Günlüğü',
            icon: Camera,
            path: '/insaat/gunluk',
            bg: 'bg-info/10',
            iconColor: 'text-info',
            stat: `${gunlukStats.toplamKayit} kayıt`,
        },
        {
            title: 'Malzeme Takibi',
            icon: Package,
            path: '/insaat/kaba/beton',
            bg: 'bg-warning/10',
            iconColor: 'text-warning',
            stat: 'Beton / Demir / İzolasyon',
        },
        {
            title: 'Projeler & İlerleme',
            icon: TrendingUp,
            path: '/insaat/projeler',
            bg: 'bg-success/10',
            iconColor: 'text-success',
            stat: `Ort. %${ortalamaIlerleme}`,
        },
    ];

    return (
        <div>
            <h2 className="text-base font-semibold text-text-primary mb-3">Hızlı Erişim</h2>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
                {kartlar.map((item) => (
                    <button
                        key={item.path}
                        onClick={() => navigate(item.path)}
                        className={clsx(
                            'group flex items-center gap-3 p-3.5 rounded-xl border border-border-light',
                            'bg-bg-primary hover:shadow-md hover:border-primary/20',
                            'transition-all duration-200 text-left active:scale-[0.98]'
                        )}
                    >
                        <div className={clsx('w-10 h-10 rounded-lg flex items-center justify-center shrink-0', item.bg)}>
                            <item.icon size={20} className={item.iconColor} />
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className="text-sm font-semibold text-text-primary group-hover:text-primary transition-colors truncate">
                                {item.title}
                            </p>
                            <p className="text-xs text-text-muted truncate">{item.stat}</p>
                        </div>
                        <ChevronRight size={16} className="text-text-muted group-hover:text-primary transition-colors shrink-0" />
                    </button>
                ))}
            </div>
        </div>
    );
}
